/* Línea Intelisset — mapa de la red, resaltado de líneas y lugares en la ficha del viaje. */
(() => {
  const NS = 'http://www.w3.org/2000/svg';
  // Direcciones octilineales, como en un mapa del Metro
  const DIR = { E: [1, 0], NE: [1, -1], SE: [1, 1], N: [0, -1], S: [0, 1], W: [-1, 0], NW: [-1, -1], SW: [-1, 1] };
  const ORDEN = {
    1: ['E'], 2: ['E', 'W'], 3: ['NE', 'SE', 'W'], 4: ['NE', 'SE', 'NW', 'SW'],
    5: ['NE', 'E', 'SE', 'NW', 'SW'], 6: ['NE', 'E', 'SE', 'NW', 'W', 'SW'],
    7: ['NE', 'E', 'SE', 'NW', 'W', 'SW', 'N'], 8: ['NE', 'E', 'SE', 'NW', 'W', 'SW', 'N', 'S']
  };
  const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

  const nodo = (tag, attrs = {}, padre) => {
    const n = document.createElementNS(NS, tag);
    for (const [k, v] of Object.entries(attrs)) n.setAttribute(k, v);
    if (padre) padre.appendChild(n);
    return n;
  };

  // Punto a una distancia s sobre una polilínea
  const puntoEn = (pts, s) => {
    for (let i = 1; i < pts.length; i++) {
      const [x0, y0] = pts[i - 1], [x1, y1] = pts[i];
      const l = Math.hypot(x1 - x0, y1 - y0);
      if (s <= l || i === pts.length - 1) {
        const t = l ? Math.min(s / l, 1) : 0;
        return [x0 + (x1 - x0) * t, y0 + (y1 - y0) * t];
      }
      s -= l;
    }
    return pts[pts.length - 1];
  };

  function pictograma(cont, nombre, x, y, lado, color, tinta) {
    const tpl = cont.querySelector(`template[data-picto="${nombre}"]`) || cont.querySelector('template[data-picto="estacion"]');
    const g = nodo('g', { class: 'red__tile', transform: `translate(${x} ${y})` });
    nodo('rect', { width: lado, height: lado, rx: lado * 0.22, fill: color }, g);
    if (tpl) {
      const svg = tpl.content.firstElementChild.cloneNode(true);
      const m = lado * 0.14;
      svg.setAttribute('x', m); svg.setAttribute('y', m);
      svg.setAttribute('width', lado - 2 * m); svg.setAttribute('height', lado - 2 * m);
      svg.setAttribute('class', 'red__picto');
      svg.style.color = tinta || '#fff';
      g.appendChild(svg);
    }
    return g;
  }

  function dibujar(cont) {
    const svg = cont.querySelector('[data-red-svg]');
    const datosEl = cont.querySelector('[data-red-datos]');
    if (!svg || !datosEl) return;
    let lineas;
    try { lineas = JSON.parse(datosEl.textContent).slice(0, 8); } catch (e) { return; }
    if (!lineas.length) { svg.remove(); return; }

    const movil = svg.parentElement.clientWidth < 560;
    cont.classList.toggle('red--movil', movil);
    const W = movil ? 400 : 1000, H = movil ? 350 : 720;
    const cx = W / 2, cy = H / 2;
    const r0 = movil ? 28 : 50, l1 = movil ? 46 : 120;
    svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
    svg.replaceChildren();

    const capaLineas = nodo('g', { class: 'red__capa-lineas' }, svg);
    const capaPlacas = nodo('g', { class: 'red__capa-placas' }, svg);
    const dirs = ORDEN[lineas.length];

    lineas.forEach((ln, i) => {
      const clave = dirs[i];
      const [dx, dy] = DIR[clave];
      const k = dx && dy ? Math.SQRT1_2 : 1;
      const ux = dx * k, uy = dy * k;
      // tramo corto en las líneas puramente horizontales para que su placa quepa
      const l2 = movil ? (dy === 0 ? 34 : 30) : (dy === 0 ? 60 : 110);
      const p0 = [cx + ux * r0, cy + uy * r0];
      const p1 = [cx + ux * (r0 + l1), cy + uy * (r0 + l1)];
      const hx = dx !== 0 ? dx : 0, hy = dx !== 0 ? 0 : dy;
      const p2 = [p1[0] + hx * l2, p1[1] + hy * l2];
      const pts = [p0, p1, p2];
      const largo = l1 + l2;

      const g = nodo('g', { class: 'red__linea' + (ln.ok ? '' : ' red__linea--agotada'), 'data-h': ln.h }, capaLineas);
      const trazo = nodo('path', {
        d: `M${p0[0]} ${p0[1]} L${p1[0]} ${p1[1]} L${p2[0]} ${p2[1]}`,
        stroke: ln.c, class: 'red__trazo', fill: 'none'
      }, g);
      trazo.style.setProperty('--largo', largo);
      trazo.style.setProperty('--i', i);

      // Estaciones repartidas sobre la línea; la última queda en la punta
      const n = ln.e.length;
      // de la punta hacia CDMX, con un espacio parejo que nunca amontona las estaciones
      const paso = n > 1 ? Math.min((largo * 0.86) / (n - 1), movil ? 30 : 48) : 0;
      ln.e.forEach((est, j) => {
        const s = largo - (n - 1 - j) * paso;
        const [x, y] = puntoEn(pts, s);
        const c = nodo('circle', { cx: x, cy: y, r: movil ? 3.6 : 7, class: 'red__est' }, g);
        c.style.setProperty('--i', i);
        nodo('title', {}, c).textContent = est.n;
      });

      // Placa del destino en la punta: pictograma principal + nombre, fechas y apartado
      const principal = (ln.e.find(e => e.m) || ln.e[ln.e.length - 1] || {}).p || 'estacion';
      const a = nodo('a', { href: ln.u, class: 'red__placa', 'data-h': ln.h }, capaPlacas);
      a.style.setProperty('--i', i);
      const lado = movil ? 34 : 58;
      const sep = movil ? 8 : 14;
      let tx, ty;
      if (dx > 0) { tx = p2[0] + sep; ty = p2[1] - lado / 2; }
      else if (dx < 0) { tx = p2[0] - sep - lado; ty = p2[1] - lado / 2; }
      else if (dy < 0) { tx = p2[0] - lado / 2; ty = p2[1] - sep - lado; }
      else { tx = p2[0] - lado / 2; ty = p2[1] + sep; }
      a.appendChild(pictograma(cont, principal, tx, ty, lado, ln.c, ln.t));
      nodo('title', {}, a).textContent = `${ln.n}${ln.f ? ', ' + ln.f : ''}${ln.ok ? ', aparta con ' + ln.a : ', agotado'}`;

      if (movil) {
        const yTexto = dy < 0 && dx === 0 ? ty - 6 : ty + lado + 14;
        nodo('text', { x: tx + lado / 2, y: yTexto, 'text-anchor': 'middle', class: 'red__placa-movil' }, a).textContent = ln.n;
      } else {
        const izq = dx < 0;
        const vertical = dx === 0;
        let x = izq ? tx - 12 : tx + lado + 12;
        let y = ty + 4;
        let anchor = izq ? 'end' : 'start';
        if (vertical) { x = tx + lado + 12; anchor = 'start'; }
        const texto = nodo('text', { x, y, 'text-anchor': anchor, class: 'red__placa-texto' }, a);
        nodo('tspan', { x, dy: '1.05em', class: 'red__placa-nombre' }, texto).textContent = ln.n;
        if (ln.f) nodo('tspan', { x, dy: '1.5em', class: 'red__placa-fechas' }, texto).textContent = ln.f;
        nodo('tspan', { x, dy: '1.45em', class: 'red__placa-tarifa' }, texto).textContent = ln.ok ? `Aparta con ${ln.a}` : 'Agotado';
      }
    });

    // Terminal CDMX al centro, encima de todas las líneas
    const t = nodo('g', { class: 'red__terminal' }, svg);
    nodo('circle', { cx, cy, r: r0, class: 'red__terminal-anillo' }, t);
    nodo('text', { x: cx, y: cy, 'text-anchor': 'middle', 'dominant-baseline': 'central', class: 'red__terminal-texto' }, t).textContent = 'CDMX';

    if (!sinMovimiento.matches && !cont.dataset.trazado) {
      cont.classList.add('red--trazando');
      requestAnimationFrame(() => requestAnimationFrame(() => cont.classList.add('red--trazado')));
      // si la animación no llegara a correr, el mapa queda completo de todos modos
      setTimeout(() => cont.classList.remove('red--trazando'), 2600);
    }
    cont.dataset.trazado = '1';
  }

  function resaltar(cont, h) {
    cont.classList.toggle('hay-activa', !!h);
    cont.querySelectorAll('[data-h], .lf[data-linea]').forEach((el) => {
      const clave = el.dataset.h || el.dataset.linea;
      el.classList.toggle('es-activa', !!h && clave === h);
    });
  }

  function iniciarRed(cont) {
    dibujar(cont);
    let ancho = cont.clientWidth;
    new ResizeObserver(() => {
      if (Math.abs(cont.clientWidth - ancho) > 40) { ancho = cont.clientWidth; dibujar(cont); }
    }).observe(cont);

    const activar = (e) => {
      const el = e.target.closest('.lf[data-linea], .red__placa, .red__linea');
      resaltar(cont, el ? el.dataset.linea || el.dataset.h : null);
    };
    cont.addEventListener('pointerover', activar);
    cont.addEventListener('focusin', activar);
    cont.addEventListener('pointerleave', () => resaltar(cont, null));
    cont.addEventListener('focusout', (e) => { if (!cont.contains(e.relatedTarget)) resaltar(cont, null); });
  }

  // Ficha del viaje: lugares − / + y el monto del botón al día
  const pesos = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
  function iniciarFicha(form) {
    const input = form.querySelector('input[name="quantity"]');
    const monto = form.querySelector('.ficha__btn-monto');
    const texto = form.querySelector('.ficha__btn-texto');
    const apartado = Number(form.dataset.apartado) || 0;
    const pintar = () => {
      const n = Math.min(Math.max(parseInt(input.value, 10) || 1, 1), 20);
      input.value = n;
      if (monto && apartado) monto.textContent = pesos.format(apartado * n).replace(/\s?MXN/, '');
      if (texto) texto.textContent = n === 1 ? 'Apartar mi lugar' : `Apartar ${n} lugares`;
    };
    form.querySelector('.ficha__menos')?.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) - 1; pintar(); });
    form.querySelector('.ficha__mas')?.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; pintar(); });
    input.addEventListener('change', pintar);
    pintar();
  }

  const iniciar = () => {
    document.querySelectorAll('[data-red]').forEach(iniciarRed);
    document.querySelectorAll('.ficha__form').forEach(iniciarFicha);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  // Editor de temas de Shopify: volver a dibujar al cambiar la sección
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-red]').forEach(iniciarRed);
    e.target.querySelectorAll('.ficha__form').forEach(iniciarFicha);
  });
})();
